export class PieChartCommons {
  public static get colors() {
    return [
      '#B3DAFC',
      '#F5D723',
      '#F5A167',
      '#2696F6',
      '#CACACA',
      '#EF7122',
      '#E7490D',
      '#0054EC',
      '#0071F1',
      '#FDEFE5',
      '#A6A6A6',
    ];
  }

  public static getRandomColor() {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }
}
